import * as ng from 'angular';
import { Event } from './shared/event.model';

ng.module('e360')
   .filter('eventLocation', () => eventLocationFilter);

/**
 * Event location for use in event lists. Returns "city, sate code" when event
 * has city name provided. Otherwise return "state name".
 * @param event
 */
export function eventLocationFilter(event:Event) {
   return event.cityName ? `${event.cityName}, ${event.state.code}` : event.state.name;
}
